var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "igc-playbook" }, [
    _c(
      "div",
      {
        staticClass: "ig--wrapper",
        style: { background: _vm.mBackground(17, "bottom") }
      },
      [
        _c(
          "router-link",
          {
            directives: [
              {
                name: "dmp",
                rawName: "v-dmp",
                value: {
                  action: "click,pop",
                  targetid: _vm.playbook.iId,
                  targettype: "moment",
                  title: _vm.playbook.sTitle,
                  from: "ingame"
                },
                expression:
                  "{action:'click,pop', targetid: playbook.iId, targettype: 'moment', title: playbook.sTitle, from: 'ingame'}"
              }
            ],
            staticClass: "ig--content",
            attrs: {
              to: {
                name:
                  _vm.playbook.iInfoType == 1 ? "detail-news" : "detail-video",
                params: { id: _vm.playbook.iId }
              }
            }
          },
          [
            _c(
              "div",
              { staticClass: "ig--poster" },
              [
                _vm.playbook.iInfoType == 2
                  ? _c("div", { staticClass: "ig--icon" })
                  : _vm._e(),
                _c("sui-image", {
                  attrs: {
                    src: _vm.mImageView(_vm.playbook.sIMG, "/1/w/315/h/210")
                  }
                })
              ],
              1
            ),
            _c("div", { staticClass: "ig--info" }, [
              _c(
                "div",
                {
                  staticClass: "ig--title ig-style--ellipsis",
                  style: { color: _vm.mColor(1) }
                },
                [_vm._v(_vm._s(_vm.playbook.sTitle))]
              ),
              _c(
                "div",
                { staticClass: "ig--num" },
                [
                  _c("sui-icon", {
                    staticClass: "ig--icon",
                    attrs: { name: "eye-outline", fill: _vm.mColor(3) }
                  }),
                  _c(
                    "div",
                    {
                      staticClass: "ig--text",
                      style: { color: _vm.mColor(3) }
                    },
                    [_vm._v(_vm._s(_vm.playbook.iTotalPlay))]
                  ),
                  _vm.playbook.igNum
                    ? _c("sui-icon", {
                        staticClass: "ig--icon",
                        attrs: { name: "message-outline", fill: _vm.mColor(3) }
                      })
                    : _vm._e(),
                  _vm.playbook.igNum
                    ? _c(
                        "div",
                        {
                          staticClass: "ig--text",
                          style: { color: _vm.mColor(3) }
                        },
                        [_vm._v(_vm._s(_vm.playbook.igNum.comment))]
                      )
                    : _vm._e()
                ],
                1
              )
            ])
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }